import { render, staticRenderFns } from "./c-release-table.vue?vue&type=template&id=572f462b&scoped=true"
import script from "./c-release-table.vue?vue&type=script&lang=js"
export * from "./c-release-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572f462b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('572f462b')) {
      api.createRecord('572f462b', component.options)
    } else {
      api.reload('572f462b', component.options)
    }
    module.hot.accept("./c-release-table.vue?vue&type=template&id=572f462b&scoped=true", function () {
      api.rerender('572f462b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/mconfigs/views/release/c-release-table.vue"
export default component.exports